import { updateConsultationTemplate } from "@/dispatchers/patientDispatchers";

export async function clearSavedPathwayState(consultationId: string): Promise<void> {
  if (!consultationId) return;
  try {
    await updateConsultationTemplate({
      consultationId,
      payload: [],
    });
  } catch (err) {
    console.error("[PathwaySaveResume] failed to clear saved state:", err);
  }
}
